"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var uno_js_1 = require("uno-js");

exports.useUrlId = function (idName, window) {
  var _a = React.useState(null),
      getId = _a[0],
      setId = _a[1];

  React.useEffect(function () {
    setId(uno_js_1.getQueryParam(idName, window.location.href));
  }, [idName, window.location]);

  var getBaseUrl = function getBaseUrl() {
    return window.location.href.split('?')[0];
  };

  var reset = function reset() {
    return window.history.pushState('', '', getBaseUrl());
  };

  var complete = function complete() {
    return window.history.pushState('', '', getBaseUrl() + "?" + idName + "=" + getId);
  };

  return [getId, reset, complete];
};